import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-brand">
            <img src="/attenxion_logo.png" alt="Attenxion" className="footer-logo" />
            <p className="footer-tagline">
            Empowering people to finish what matters.
            </p>
          </div>
          
          <div className="social-links">
            <a href="https://www.facebook.com/profile.php?id=61577883884300" aria-label="Facebook" className="social-link" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.linkedin.com/company/attenxion/" aria-label="LinkedIn" className="social-link" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://x.com/attenxion72133" aria-label="Twitter" className="social-link" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="https://www.youtube.com/@Attenxion" aria-label="YouTube" className="social-link" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/attenxion.ai/" aria-labhow to make my instagram account a business accountel="Instagram" className="social-link" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>

        <p className="copyright">
          © {currentYear} Attenxion. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer; 